import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrTabComponent } from './pr-tab/pr-tab.component';
import { PrTabsComponent } from './pr-tabs/pr-tabs.component';
import { PrLabelModule } from '../pr-label/pr-label.module';

@NgModule({
  declarations: [PrTabComponent, PrTabsComponent],
  imports: [CommonModule, PrLabelModule],
  exports: [PrTabComponent, PrTabsComponent],
})
export class PrTabModule {}
